import React from 'react';
import { Row, Col, FormGroup, ControlLabel } from 'react-bootstrap';
import {
	connect
} from 'react-redux'
import FieldGroup from '../components/common/FieldGroup.jsx';
import FittingRecordEditComponent from '../components/FittingRecordEditComponent.jsx';
import {
	changeFittingRecordValue,
	editFittingRecord,
	deleteFittingRecord,
	deleteFittingRecordByItem
} from '../actions';
import {
	colorDisplay, sizingDisplay
} from '../constants/common';

// 套量件數 顯示
function generateFittingStatus(fittingRecord) {
	let fittingStatus = null;
	let itemsCount = fittingRecord.get('itemsCount');
	if (itemsCount && itemsCount > 0) {
		fittingStatus = (<p style={{ color: 'blue' }}>已套量件數: {itemsCount}</p>);
	} else {
		fittingStatus = (<p style={{ color: 'red' }}>未套量</p>);
	}
	return fittingStatus;
}

// 套量資料 顯示
function generateFittingRows(detailsNeedBespoke, fittingRecord, setValue, deleteByItem, orderId, pagingData) {
	let fittingRow = [];
	let bdArray = detailsNeedBespoke;
	var arrayLength = bdArray.size;
	for (var i = 0; i < arrayLength; i++) {
		let bd = bdArray.get(i);
		let _item_id = "_" + bd.get('order_detail_id') + "t_item_id";
		let _color = "_" + bd.get('order_detail_id') + "t_color";
		let _sizing = "_" + bd.get('order_detail_id') + "t_sizing";
		let _note = "_" + bd.get('order_detail_id') + "t_note";
		let colorArray = [];
		let sizeArray = [];
		if (bd.get('color_values')) {
			colorArray = bd.get('color_values').split(",");
		}
		if (bd.get('size_values')) {
			sizeArray = bd.get('size_values').split(",");
		}
		let spec_id = "";
		if (bd.get('spec_id')) {
			spec_id = bd.get('spec_id');
		}
		let colorLabel = bd.get('customer_gear_name') + "-" + spec_id + " 顏色";
		let sizingLabel = bd.get('customer_gear_name') + "-" + spec_id + " 尺寸";
		let noteLabel = bd.get('customer_gear_name') + "-" + spec_id + " 備註";
		let noteValue = '';
		if (fittingRecord.get(_note)) {
			noteValue = fittingRecord.get(_note);
		}
		fittingRow.push((
			<Row key={bd.get('order_detail_id')}>
				<Col xs={12} sm={4} md={4}>
					<FormGroup>
						<ControlLabel>{colorLabel}</ControlLabel><br />
						{
							colorArray.map((colorValue, key) => (
								<span key={_color + '_' + key} style={{ paddingRight: 5 }}><input type="radio" name={_color} value={colorValue} onChange={(event) => {
									setValue(_color, event.target.value)
								}} checked={fittingRecord.get(_color) === colorValue} />{colorDisplay(colorValue)}</span>
							))
						}
					</FormGroup>
				</Col>
				<Col xs={12} sm={4} md={4}>
					<FormGroup>
						<ControlLabel>{sizingLabel}</ControlLabel><br />
						{
							sizeArray.map((sizeValue, key) => (
								<span key={_sizing + '_' + key} style={{ paddingRight: 5 }}><input type="radio" name={_sizing} value={sizeValue} onChange={(event) => {
									setValue(_sizing, event.target.value)
								}} checked={fittingRecord.get(_sizing) === sizeValue} />{sizingDisplay(sizeValue)}</span>
							))
						}
					</FormGroup>
				</Col>
				<Col xs={12} sm={3} md={3}>
					<FieldGroup id={_note}
						type="text"
						label={noteLabel}
						value={noteValue}
						onChange={(id, value) => {
							setValue(id, value);
						}}
					/>
				</Col>
				<Col xs={12} sm={1} md={1}>
					<ControlLabel>清除</ControlLabel><br />
					<span className="glyphicon glyphicon-trash" style={{ color: '#a94442', cursor: 'pointer' }}
						onClick={(event) => {
							deleteByItem({ orderId: orderId, itemId: fittingRecord.get(_item_id), suitId: fittingRecord.get("suit_id")}, pagingData);
						}} />
				</Col>
			</Row>
		));
	}
	return fittingRow;
}

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	orderer: state.getIn(['fittingReducer', 'orderer']),
	fittingRecord: state.getIn(['fittingReducer', 'fittingRecord']),
	alertStyle: state.getIn(['fittingReducer', 'alertStyle']),
	alertMessage: state.getIn(['fittingReducer', 'alertMessage']),
	detailsNeedBespoke: state.getIn(['fittingReducer', 'detailsNeedBespoke']),

	activePage: state.getIn(['fittingListReducer', 'activePage']),
	itemPerPage: state.getIn(['fittingListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
	setValue: (id, value) => {
		dispatch(changeFittingRecordValue({
			id: id,
			value: value
		}))
	},
	editFittingRecord: (fittingRecord, pk, pagingData) => {
		dispatch(editFittingRecord(fittingRecord, pk, pagingData))
	},
	deleteFittingRecord: (payload, pagingData) => {
		dispatch(deleteFittingRecord(payload, pagingData))
	},
	deleteByItem: (payload, pagingData) => {
		dispatch(deleteFittingRecordByItem(payload, pagingData))
	}
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	orderId: stateProps.orderId,
	orderer: stateProps.orderer,
	fittingRecord: stateProps.fittingRecord,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	detailsNeedBespoke: stateProps.detailsNeedBespoke,
	fittingStatus: generateFittingStatus(stateProps.fittingRecord),
	fittingRows: generateFittingRows(stateProps.detailsNeedBespoke, stateProps.fittingRecord
		, dispatchProps.setValue, dispatchProps.deleteByItem, stateProps.orderId, {
			activePage: stateProps.activePage,
			itemPerPage: stateProps.itemPerPage
		}),
	setValue: dispatchProps.setValue,
	editFittingRecord: () => dispatchProps.editFittingRecord(stateProps.fittingRecord, {
		orderId: stateProps.orderId
	}, {
			activePage: stateProps.activePage,
			itemPerPage: stateProps.itemPerPage
		}),
	deleteFittingRecord: () => dispatchProps.deleteFittingRecord({
		orderId: stateProps.orderId,
		suitId: stateProps.fittingRecord.get('suit_id')
	}, {
			activePage: stateProps.activePage,
			itemPerPage: stateProps.itemPerPage
		}),
})

const FittingRecordEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(FittingRecordEditComponent)

export default FittingRecordEditContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingRecordEditContainer.jsx